/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Version: 1.1
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

const mutations = {
    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    UPDATE_THEME(state, val) {
        state.theme = val;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val;
    },
    UPDATE_AUTH_TOKEN(state, val) {
        state.authToken = val;
    },
    UPDATE_USER_INFO(state, val) {
        state.uInfo = val;
    },
    UPDATE_IS_UPGRADE_PLAN(state, val) {
        state.is_upgrade_plan = val;
    },
    UPDATE_LIVESTATUS_INFO(state, val) {
        state.liveStatus = val; //old 
        state.uInfo.inoutreference = val;
        localStorage.setItem("user", JSON.stringify(state.uInfo));
    },

    UPDATE_NO_OF_USERS(state, val) {
        state.noOfUsers = val;
    },
    UPDATE_USER_SUBSCRIPTION_INFO(state, data) {
        if (data) {
            state.uInfo.payment_plan = data.payment_plan;
            state.uInfo.expiry_date = data.expiry_date;
            state.uInfo.is_plan_expire = data.is_plan_expire;
            state.uInfo.stripe_plan_id = data.stripe_plan_id;
            localStorage.setItem("user", JSON.stringify(state.uInfo));
        }
    },
    UPDATE_USER_DETAILS(state, data) {
        if (data) {
            state.uInfo.org_image = data.logo;
            state.uInfo.org_name = data.name;
            state.uInfo.organization = data.id;
            state.uInfo.time_zone = data.time_zone;
            state.uInfo.is_profile_complete = data.is_profile_complete;
            localStorage.setItem("user", JSON.stringify(state.uInfo));
        }
    },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    UPDATE_STARRED_PAGE(state, payload) {
        const index = state.navbarSearchAndPinList.data.findIndex(
            item => item.index == payload.index
        );
        state.navbarSearchAndPinList.data[index].highlightAction = payload.val;
    },
    UPDATE_DASHBOARD_PAGINATION_WIDTH(state, perpage) {
        state.dashboardPagination = perpage;
    },
};

export default mutations;